"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// @ts-ignore
var isEqual = require("lodash/isEqual");
var Tab_1 = require("../Tab/Tab");
var animations_1 = require("../../../common/animations");
var dataHooks_1 = require("../dataHooks");
var ScrollableTabs_st_css_1 = require("./ScrollableTabs.st.css");
var ScrollableTabs = /** @class */ (function (_super) {
    __extends(ScrollableTabs, _super);
    function ScrollableTabs(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedIndicatorRect: {
                left: 0,
                width: 0,
            },
        };
        _this._scrollToViewIfNeeded = function (newSelectedTab) {
            var _a = _this.props, rtl = _a.rtl, scrollButtons = _a.scrollButtons;
            var left = scrollButtons.left, right = scrollButtons.right;
            if (_this._selectedTabRef && _this._selectedTabRef.current) {
                var currentTabElement = _this._selectedTabRef.current;
                var navElement = _this._navRef.current;
                var leftLimit = navElement.scrollLeft;
                var rightLimit = leftLimit + navElement.clientWidth;
                var leftDelta = currentTabElement.offsetLeft - leftLimit;
                var rightDelta = currentTabElement.offsetLeft +
                    currentTabElement.clientWidth -
                    rightLimit;
                var buttonGap = rtl ? right : left;
                var scrollAmount = currentTabElement.offsetLeft - buttonGap;
                if (rtl) {
                    scrollAmount =
                        navElement.scrollWidth -
                            (navElement.offsetWidth -
                                (currentTabElement.offsetLeft +
                                    buttonGap +
                                    currentTabElement.offsetWidth)) -
                            navElement.offsetWidth;
                }
                if (newSelectedTab || leftDelta < 0 || rightDelta > 0) {
                    _this._animateScroll(scrollAmount);
                }
            }
        };
        _this._navRef = React.createRef();
        _this._listRef = React.createRef();
        _this._selectedTabRef = React.createRef();
        return _this;
    }
    ScrollableTabs.prototype.componentDidMount = function () {
        this._updateComponent();
    };
    ScrollableTabs.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.activeTabIndex !== this.props.activeTabIndex ||
            !isEqual(prevProps.items, this.props.items) ||
            prevProps.alignment !== this.props.alignment ||
            prevProps.variant !== this.props.variant) {
            this._updateComponent(prevProps.activeTabIndex !== this.props.activeTabIndex);
        }
    };
    ScrollableTabs.prototype.updateIndicatorPosition = function () {
        this._updateIndicatorPosition();
    };
    ScrollableTabs.prototype._updateComponent = function (newSelectedTab) {
        if (newSelectedTab === void 0) { newSelectedTab = false; }
        this._updateIndicatorPosition();
        this._scrollToViewIfNeeded(newSelectedTab);
    };
    ScrollableTabs.prototype._updateIndicatorPosition = function () {
        var selectedIndicatorRect = this.state.selectedIndicatorRect;
        if (this._selectedTabRef && this._selectedTabRef.current) {
            var newLeft = this._selectedTabRef.current.offsetLeft;
            var newWidth = this._selectedTabRef.current.offsetWidth;
            if (selectedIndicatorRect.left !== newLeft ||
                selectedIndicatorRect.width !== newWidth) {
                this.setState({
                    selectedIndicatorRect: { left: newLeft, width: newWidth },
                });
            }
        }
    };
    ScrollableTabs.prototype._getMaxMinScroll = function () {
        var navElement = this._navRef.current;
        return {
            max: navElement.scrollWidth - navElement.offsetWidth,
            min: 0,
        };
    };
    ScrollableTabs.prototype._animateScroll = function (scrollLeft) {
        var _this = this;
        if (this._cancelAnimation) {
            this._cancelAnimation();
        }
        var _a = this._getMaxMinScroll(), min = _a.min, max = _a.max;
        var moveTo = Math.min(Math.max(scrollLeft, min), max);
        var _b = animations_1.animateElementByProp({
            propToAnimate: 'scrollLeft',
            element: this._navRef.current,
            moveTo: moveTo,
            duration: 400,
        }), cancel = _b.cancel, done = _b.done;
        this._cancelAnimation = cancel;
        done
            .then(function () {
            _this._cancelAnimation = null;
        })
            .catch(function () { });
    };
    ScrollableTabs.prototype.scrollLeft = function () {
        this._scrollToSide(-1);
    };
    ScrollableTabs.prototype.scrollRight = function () {
        this._scrollToSide(1);
    };
    ScrollableTabs.prototype._scrollToSide = function (scrollDirection) {
        var scrollLeft = this._navRef.current.scrollLeft;
        var clientWidth = this._navRef.current.clientWidth;
        var scrollDistance = scrollDirection * (clientWidth / 2);
        this._animateScroll(scrollLeft + scrollDistance);
    };
    ScrollableTabs.prototype.getNavScrollPosition = function () {
        var scrollPosition = { scrollLeft: 0, scrollRight: 0 };
        if (this._navRef && this._navRef.current) {
            var element = this._navRef.current;
            scrollPosition.scrollLeft = element.scrollLeft;
            scrollPosition.scrollRight =
                element.scrollWidth - (element.scrollLeft + element.offsetWidth);
        }
        return scrollPosition;
    };
    ScrollableTabs.prototype._getDataAttributes = function () {
        var _a;
        var _b = this.props, alignment = _b.alignment, variant = _b.variant;
        return _a = {},
            _a[dataHooks_1.TABS_DATA_KEYS.alignment] = alignment,
            _a[dataHooks_1.TABS_DATA_KEYS.variant] = variant,
            _a;
    };
    ScrollableTabs.prototype.render = function () {
        var _this = this;
        var selectedIndicatorRect = this.state.selectedIndicatorRect;
        var _a = this.props, activeTabIndex = _a.activeTabIndex, onClickItem = _a.onClickItem, onScroll = _a.onScroll, items = _a.items, alignment = _a.alignment, variant = _a.variant, animateIndicator = _a.animateIndicator, rest = __rest(_a, ["activeTabIndex", "onClickItem", "onScroll", "items", "alignment", "variant", "animateIndicator"]);
        return (React.createElement("div", __assign({}, ScrollableTabs_st_css_1.default('root', { alignment: alignment, variant: variant, animateIndicator: animateIndicator }, rest), this._getDataAttributes(), { "data-hook": dataHooks_1.TABS_DATA_HOOKS.scrollableTabs }),
            React.createElement("nav", { className: ScrollableTabs_st_css_1.default.nav, ref: this._navRef, onScroll: onScroll },
                React.createElement("ul", { className: ScrollableTabs_st_css_1.default.itemsList, ref: this._listRef }, items.map(function (item, index) { return (React.createElement(Tab_1.Tab, { key: item.title + "-" + index, className: ScrollableTabs_st_css_1.default.tab, item: item, index: index, "data-hook": dataHooks_1.TABS_DATA_HOOKS.tab + "-" + index, isActive: activeTabIndex === index, indicateActive: !animateIndicator, ref: activeTabIndex === index ? _this._selectedTabRef : null, onClick: onClickItem })); })),
                React.createElement("div", { className: ScrollableTabs_st_css_1.default.selectedIndicator, style: selectedIndicatorRect })),
            React.createElement("div", { className: ScrollableTabs_st_css_1.default.border })));
    };
    ScrollableTabs.defaultProps = {
        scrollButtons: {
            left: 0,
            right: 0,
        },
    };
    return ScrollableTabs;
}(React.Component));
exports.ScrollableTabs = ScrollableTabs;
//# sourceMappingURL=ScrollableTabs.js.map